




























































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/agiles/common';

@Component
export default class SystemLogView extends Vue {
  public items: Common.SystemLog[] = new Array();
  public params: Common.SystemLogQuery = new Common.SystemLogQuery();

  public sortOptions: any = [
    { value: 'startTime', text: '開始時刻' },    
    { value: 'title', text: 'タイトル' },
    { value: 'status', text: '処理状態' },
];

  @Prop() public id:number;

  public created(){
    if (this.id) this.params.id = this.id;
  }
  public onSelectedMain(index: number, selected: Common.SystemLog) {
    //descriptionをセット
    this.$api.find('SystemLog', [selected.id]).then(res =>{
      selected.description = (res as Common.SystemLog).description;
    });
  }  
}
